import type { AppliedFilter, FilterArrayItem } from '../ControlTower/types';

export type FilterLogic = 'AND' | 'OR';

export const DEFAULT_FILTER_LOGIC: FilterLogic = 'OR';

export const FILTER_LOGIC_KEYS = [
  'product',
  'team',
  'teams',
  'alert_types',
  'location_type',
  'product_type',
  'project_id',
] as const;

const FILTER_LOGIC_KEY_SET = new Set<string>(FILTER_LOGIC_KEYS);

export const supportsFilterLogic = (filterBy?: string | null): boolean =>
  !!filterBy && FILTER_LOGIC_KEY_SET.has(filterBy);

export const normalizeFilterLogic = (logic: unknown): FilterLogic =>
  String(logic).toUpperCase() === 'AND' ? 'AND' : DEFAULT_FILTER_LOGIC;

export const getAppliedFilterLogic = (
  filterBy: string,
  appliedFilters?: AppliedFilter[],
  filterArray?: FilterArrayItem[]
): FilterLogic => {
  const fromApplied = (appliedFilters || []).find(
    (filter) => filter.filterBy === filterBy || filter.dateFilter === filterBy
  )?.logic;

  if (fromApplied) return normalizeFilterLogic(fromApplied);

  const fromFilterArray = (filterArray || []).find(
    (filter) => filter.filterBy === filterBy
  )?.logic;

  return normalizeFilterLogic(fromFilterArray);
};

export const withFilterLogic = <
  T extends { filterBy?: string; logic?: unknown },
>(
  item: T,
  logic: FilterLogic
): T => {
  if (!supportsFilterLogic(item.filterBy)) return item;
  return { ...item, logic };
};
